/**
 * 允许上传的文件类型
 * @type {string}
 */
export const ACCEPT_TYPE =
  '.gif,.jpg,.psd,.png,.wav,.mp3,.wma,.ra,.midi,.ogg,.m4a,.ape,.aiff,.au,.RM,.rmvb,.mov,.rm,.mtv,.dat,.wmv,.avi,.mp4,.3gp,.amv,.dmv,.flv,.asf,.asx,.mpeg,.webm,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.pdf,.rar,.7z,.zip'
